import React from 'react';
import classNames from 'classnames';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {Button, ButtonSize, HoverStyles} from 'wix-ui-tpa/cssVars';
import {ErrorNames, ModalState} from '../../../constants';
import {IError} from '../../../types/app-types';
import s from './BuyNowButton.scss';
import {classes as buyNowButtonStyles} from './BuyNowButton.st.css';

export interface BuyNowButtonProps extends ProvidedGlobalProps, IProvidedTranslationProps {
  productInStock: boolean;
}

export enum BuyNowButtonDataHook {
  Root = 'buy-now-button',
}

class BuyNowButtonComponent extends React.Component<BuyNowButtonProps> {
  public BuyNowButtonRef = React.createRef<HTMLButtonElement>();

  public componentDidUpdate(prevProps: Readonly<BuyNowButtonProps>): void {
    if (prevProps.globals.modalState === ModalState.OPEN && this.props.globals.modalState === ModalState.CLOSE) {
      this.focusButton();
    }
  }

  public focusButton = () => {
    this.BuyNowButtonRef.current.focus();
  };

  private getCaption(
    t: Function,
    disabled: boolean,
    price: number,
    productInStock: boolean,
    errors: IError,
    addToCartState: AddToCartState,
    buyNowLabelOverride: string | null
  ): string {
    const isOutOfStockText = price > 0 || !productInStock;

    if (buyNowLabelOverride) {
      return buyNowLabelOverride;
    }

    if (disabled) {
      return isOutOfStockText ? t('PRODUCT_OUT_OF_STOCK_BUTTON') : t('ADD_TO_CART_BUTTON_PRICE_ZERO');
    }

    if (errors.errorName === ErrorNames.StoreInfoError) {
      return 'try again'; // todo(ariell): change to translation
    }

    if (addToCartState === AddToCartState.PRE_ORDER) {
      return t('productPage.preOrderNow.button');
    }

    return t('BUY_NOW_BUTTON');
  }

  public render(): JSX.Element {
    const {
      t,
      productInStock,
      globals: {accessibilityEnabled, addToCartState, errors, handleBuyNow, product, selectedVariant, labelOverrides},
    } = this.props;

    const {price} = selectedVariant || product;
    const disabled = addToCartState !== AddToCartState.ENABLED && addToCartState !== AddToCartState.PRE_ORDER;
    const caption = this.getCaption(
      t,
      disabled,
      price,
      productInStock,
      errors,
      addToCartState,
      labelOverrides.cta.buyNow
    );

    const buttonClasses = classNames(buyNowButtonStyles.buyNowButton, s.buyNowButton);

    return (
      <Button
        data-wix-hideable={true}
        hoverStyle={HoverStyles.underline}
        type="button"
        ref={this.BuyNowButtonRef}
        onClick={() => handleBuyNow(accessibilityEnabled)}
        disabled={disabled}
        data-hook={BuyNowButtonDataHook.Root}
        className={buttonClasses}
        size={ButtonSize.large}>
        {caption}
      </Button>
    );
  }
}

export const BuyNowButton = withGlobalProps(withTranslations('globals.texts')(BuyNowButtonComponent));
